import api from "@/network";

export default {
    async get() {
        return await api.get('admin/tarification')
    }
}
